import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.colors.background};

    img {
      height: auto;
      max-width: 100%;
    }
  }
  // .sc-hTZhsR{display:none}
  // .sc-iktFzd.sc-jJEJSO.kcskyj.jlZfWA{display:none}
`

export default GlobalStyle
